import axios from "./axios";

export const getApplicationByIdAPI = (applicationId, clientId) => {
    return axios.get(`/application/${applicationId}/${clientId}/history`).then(res=>{
        return res;
    }).catch(error => {
        return error?.response || error;
    });
}